import React, { useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import * as yup from "yup";
import { InputType, getTextFromHtml, handleApiErrors, validationRegex } from "../../Utils/Utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import ClassService from "../../Services/ClassService";
import DataProvider from "../../Utils/DataProvider";
import SubjectService from "../../Services/SubjectService";
import Image from "../../Components/Reusable/Image";
import RoutesPath from "../../Utils/RoutesPath";
import CustomTextEditor from "../../Components/Reusable/CustomTextEditor";
import { TitleLabel } from "../../Components/Reusable/LabelComponents";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import { ConfirmationModalTheme } from "../../Utils/Enums";
import ReviewerService from "../../Services/ReviewerService";


const ReviewerAddQuestionBank = () => {
  const [currentStep, setCurrentStep] = useState(2);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [question, setQuestion] = useState({ ...useLocation().state });
  const [allSubQuestions, setAllSubQuestions] = useState([]);
  const [resetTopicDetailsValue, setResetTopicDetailsValue] = useState(false);
  const [subQuestionToDelete, setSubQuestionToDelete] = useState(null);
  const [selectedSubQuestion, setSelectedSubQuestion] = useState({});
  const [showSubQuestionDeleteModal, setShowSubQuestionDeleteModal] = useState(false);
  const [subQuestionCorrectOption, setSubQuestionCorrectOption] = useState(null);
  const [isEditMode, setIsEditMode] = useState(!!question?.id);
  const [resetcorrectoption, setResetcorrectoption] = useState(false);
  const [resetoptions, setResetoptions] = useState(false);
  const [resetfield, setResetfield] = useState(false);

  const navigate = useNavigate();
  const stepTwoValidations = yup.object().shape({
    question: validationRegex.required,
    correctOption: validationRegex.required,
    optionOne: validationRegex.required,
    optionTwo: validationRegex.required,
    optionThree: validationRegex.required,
    optionFour: validationRegex.required,
  });

  const stepTwoValidationsForComprehensive = yup.object().shape({
    questions: validationRegex.required,

  });

  const { register: registerStepOne, handleSubmit: handleSubmitStepOne, setValue: setValuesStepOne, formState: { errors: errorsStepOne }, watch: watchStepOne, getValues: getValuesStepOne, reset: resetStepOne } = useForm({
    resolver: yupResolver(),
    defaultValues: {
      class_id: question ? question?.class_id : "",
      subject_id: question ? question?.subject_id : "",
      module: question ? question?.module_id : "",
      topic: question ? question?.topic_id : "",
      type: question ? question?.question_type : "",
      typeOfQuestion: question ? question?.type_of_question : "",
      medium: question ? question?.medium : "",
    },
  });

  const { register: registerStepTwo, handleSubmit: handleSubmitStepTwo, setValue: setValuesStepTwo, formState: { errors: errorsStepTwo }, watch: watchStepTwo, getValues: getValuesStepTwo, reset: resetStepTwo } = useForm({
    resolver: yupResolver(
      watchStepOne("typeOfQuestion") === "General" || currentStep === 2.1
        ? stepTwoValidations
        : stepTwoValidationsForComprehensive
    ),

    defaultValues: {
      question: question ? question?.question : "",
      questions: question ? question?.questions : "",
      solution: question ? question?.solution : "",
      correctOption: question ? question?.correctOption : "",
    },
  });

  const hasDuplicateOptions = (options) => {
    const uniqueOptions = new Set(options.map(option => option ? option.trim() : ''));
    return uniqueOptions.size !== options.length;
  };
  const addQuestionApiTask = async (data) => {
    var newData = { ...question }
    const options = [
      data.optionOne,
      data.optionTwo,
      data.optionThree,
      data.optionFour,
    ];

    // Check for duplicate options before proceeding
    if (question.type_of_question === "General" && hasDuplicateOptions(options)) {
      toast.error("Options must be unique."); // Show toast message
      return; // Prevent submission
    }
    if (question.type_of_question === "General") {
      newData.question = data.question;
      newData.correctOption = Number.parseInt(data.correctOption);
      newData.solution = data.solution;
      newData.optionOne = data.optionOne;
      newData.optionTwo = data.optionTwo;
      newData.optionThree = data.optionThree;
      newData.optionFour = data.optionFour;
    } else {
      newData.question = data.questions
    }
    try {
      const response = await ReviewerService.revieweraddQuestion(
        question.id || "",
        question.question_type ,
        question.type_of_question,
        newData.question,
        data.solution || "",
        data.correctOption,
        data.optionOne,
        data.optionTwo,
        data.optionThree,
        data.optionFour,
      );
      newData.id = response.question._id;
      setQuestion(newData);
      setResetTopicDetailsValue(true);
      question.type_of_question === "General"
        ? setCurrentStep(3)
        : setCurrentStep(2.1);
        toast.success("Question added successfully.");
    } catch (error) {
      handleApiErrors(error);
    }

  };

  const getAllReviewerSubQuestionList = async () => {
    try {
      const response = await ReviewerService.getAllReviewerSubQuestionList(
        question.id
      );
      const subQuestions = response.subQuestionList.map((value, index) => {
        return {
          ...value,
          optionOne: getTextFromHtml(value.optionOne.replace(/&nbsp;/g, ' ')),
          optionTwo: getTextFromHtml(value.optionTwo.replace(/&nbsp;/g, ' ')),
          optionThree: getTextFromHtml(value.optionThree.replace(/&nbsp;/g, ' ')),
          optionFour: getTextFromHtml(value.optionFour.replace(/&nbsp;/g, ' ')),
        };
      });
      setAllSubQuestions(subQuestions);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const revieweraddSubQuestion = async (data) => {
    var newData = { ...allSubQuestions };
    const options = [
      data.optionOne,
      data.optionTwo,
      data.optionThree,
      data.optionFour,
    ];

    // Check for duplicate options for Comprehensive and Poem types
    if (["Comprehensive", "Poem"].includes(question.type_of_question) && hasDuplicateOptions(options)) {
      toast.error("Options must be unique."); // Show toast message
      return; // Prevent submission
    }
    newData.question = data.question;
    newData.correctOption = Number.parseInt(data.correctOption);
    newData.solution = data.solution;
    newData.optionOne = data.optionOne;
    newData.optionTwo = data.optionTwo;
    newData.optionThree = data.optionThree;
    newData.optionFour = data.optionFour;

    try {
      const response = await ReviewerService.revieweraddSubQuestion(
        question.id,
        data.question,
        data.solution || "",
        data.correctOption,
        data.optionOne,
        data.optionTwo,
        data.optionThree,
        data.optionFour,
        selectedSubQuestion?.sub_question_id || ""
      );
      toast.success(
        selectedSubQuestion?.sub_question_id
          ? "Sub Question Updated Successfully"
          : "Sub Question Added Successfully"
      );
      setSelectedSubQuestion(null);
      setResetcorrectoption(true)
      setResetoptions(true)
      setResetfield(true)
      getAllReviewerSubQuestionList();
    } catch (error) {
      handleApiErrors(error);
    }
  };
  useEffect(() => {
    const privioustypeofQuestoin = question?.type_of_question
    const typeOfQuestionValue = watchStepOne("typeOfQuestion");
    if (typeOfQuestionValue != privioustypeofQuestoin) {
      setResetTopicDetailsValue(true);
    }
  }, [watchStepOne]);


  const deleteSubQuestionApiTask = async (data) => {
    try {
      await ReviewerService.reviewerdeleteSubQuestion(data.sub_question_id);
      toast.success("Sub Question Deleted Successfully");
      setResetTopicDetailsValue(true);
      setShowSubQuestionDeleteModal(false);
      getAllReviewerSubQuestionList();

    } catch (error) {
      handleApiErrors(error);
    }
  };

  const importantStyle = {
    marginBottom: '0px !important'
  };
  useEffect(() => {
    if (
      currentStep === 2.1 &&
      (watchStepOne("typeOfQuestion") === "Comprehensive" || watchStepOne("typeOfQuestion") === "Poem")
    ) {
      getAllReviewerSubQuestionList();
      setResetTopicDetailsValue(true);
      setResetcorrectoption(true)
      setResetoptions(true)
      setResetfield(true)
    }
  }, [currentStep]);


  useEffect(() => {
    if (currentStep === 3) {
      // Set a timeout to simulate async behavior
      const timer = setTimeout(() => {
        // Get the edited question data
        const editedQuestionData = {
          typeOfQuestion: watchStepOne("typeOfQuestion"),
          class_id: watchStepOne("class_id"),
          subject_id: watchStepOne("subject_id"),
          medium: watchStepOne("medium"),
          question: watchStepTwo("question"),
          optionOne: watchStepTwo("optionOne"),
          optionTwo: watchStepTwo("optionTwo"),
          optionThree: watchStepTwo("optionThree"),
          optionFour: watchStepTwo("optionFour"),
          correctOption: watchStepTwo("correctOption"),
          solution: watchStepTwo("solution"),
        };

        // Log the data before navigation
        console.log("Edited Question Data:", editedQuestionData);

        // Pass the question data to the next page using state
        navigate(RoutesPath.reveiwerquestionslist, {
          state: { editedQuestion: editedQuestionData },
        });
      }, 2000); // Delay of 2 seconds

      // Cleanup the timeout when the component unmounts or currentStep changes
      return () => clearTimeout(timer);
    }
  }, [currentStep, navigate]);

  return (
    <div className="content" data-number="1">
      <div className="mb-3 d-flex justify-content-between">
        <h1 className="black fs-18 fw-600 mb-0">QUESTION BANK</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Question Bank</h4>
        </div>
      </div>

      <div className="table_container">
        <div className="table_title p-0">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">{isEditMode ? 'Edit Question Bank' : 'Add Question Bank'}</h1>
          </div>
        </div>

        <div className="progress_bar">
          <div
            className={`step-${currentStep === 2.1 ? 2 : currentStep}`}
            id="checkout-progress"
            data-current-step="1"
          >
            <div className="progress-bar">
              <div
                onClick={() => navigate(RoutesPath.reveiwerquestionslist)}
                className={`step cursor-pointer step-1 ${currentStep === 1 ? "active" : currentStep > 1 ? "valid" : ""
                  }`}
              >
                <span> 01</span>
                <div className="fa fa-check opaque">
                  <Image src={SvgImages.tick_mark}></Image>
                </div>
              </div>
              <div
                onClick={() => {
                  if (currentStep > 2) setCurrentStep(2);
                }}
                className={`step cursor-pointer step-2 ${currentStep === 2 || currentStep === 2.1
                  ? "active"
                  : currentStep > 2 || currentStep > 2.1
                    ? "valid"
                    : ""
                  }`}
              >
                <span> 02</span>
                <div className="fa fa-check opaque">
                  <Image src={SvgImages.tick_mark}></Image>
                </div>
              </div>
              <div
                className={`step cursor-pointer step-3 ${currentStep === 3 ? "active" : currentStep > 3 ? "valid" : ""
                  }`}
              >
                <span> 03</span>
                <div className="fa fa-check opaque">
                  <Image src={SvgImages.tick_mark}></Image>
                </div>
              </div>
            </div>
          </div>
        </div>
        {currentStep === 2 || currentStep === 2.1 ? (
          <form onSubmit={(currentStep === 2.1) ? handleSubmitStepTwo(revieweraddSubQuestion) : handleSubmitStepTwo(addQuestionApiTask)}>
            {currentStep === 2.1 && (
              <>
                <TitleLabel
                  text={"Parent Question"}
                  className="login_heading"
                />
                <div className=" d-flex justify-content-between align-items-center parent-question-box mt-2 mb-4">
                  <div className="w-75 text-truncate primary fw-600 fs-16 cursor-pointer"title={getTextFromHtml(question.question.replace(/&nbsp;/g, ' '))}> {getTextFromHtml(question.question.replace(/&nbsp;/g, ' '))}</div>
                  <div className="editbox d-flex justify-content-center cursor-pointer"onClick={() => setCurrentStep(2)}>
                    <Image
                      src={SvgImages.edit}
                      style={{height:18,width:18}}
              
                    />
                  </div>

                </div>
              </>
            )}
            <div className="d-flex flex-column gap-2">
              <div className="d-flex gap-4 w-100">
                {watchStepOne("typeOfQuestion") === "General" ||
                  currentStep === 2.1 ? (
                  <div
                    className={`d-flex flex-column ${watchStepOne("typeOfQuestion") === "General"
                      ? "w-100"
                      : "w-50"
                      }`}
                  >
                    <CustomTextEditor
                      labelTitle={"Question"}
                      name="question"
                      id="question"
                      updateValue={currentStep === 2.1 ? "" : question.question}
                      setValue={setValuesStepTwo}
                      setResetValue={setResetfield}
                      resetValue={resetfield}
                      showError={errorsStepTwo?.question}
                      errorMessage={errorsStepTwo?.question?.message}
                      showMandatory={true}
                      defaultValue={
                        (currentStep === 2.1 && selectedSubQuestion?.question) || (currentStep === 2 && question?.question) || ""
                      }
                    />

                    <CustomTextEditor
                      labelTitle={"Option A"}
                      name="optionOne"
                      id="optionOne"
                      setValue={setValuesStepTwo}
                      setResetValue={setResetoptions}
                      resetValue={resetoptions}
                      showError={errorsStepTwo?.optionOne}
                      errorMessage={errorsStepTwo?.optionOne?.message}
                      showMandatory={true}
                      defaultValue={(
                        currentStep === 2.1 && selectedSubQuestion?.optionOne) || (currentStep === 2 && question?.options[0]) || ""
                      }
                    />

                    <CustomTextEditor
                      labelTitle={"Option B"}
                      name="optionTwo"
                      id="optionTwo"
                      setValue={setValuesStepTwo}
                      setResetValue={setResetoptions}
                      resetValue={resetoptions}
                      showError={errorsStepTwo?.optionTwo}
                      errorMessage={errorsStepTwo?.optionTwo?.message}
                      showMandatory={true}
                      defaultValue={(
                        currentStep === 2.1 && selectedSubQuestion?.optionTwo) || (currentStep === 2 && question?.options[1]) || ""
                      }
                    />

                    <CustomTextEditor
                      labelTitle={"Option C"}
                      name="optionThree"
                      id="optionThree"
                      setValue={setValuesStepTwo}
                      setResetValue={setResetoptions}
                      resetValue={resetoptions}
                      showError={errorsStepTwo?.optionThree}
                      errorMessage={errorsStepTwo?.optionThree?.message}
                      showMandatory={true}
                      defaultValue={(
                        currentStep === 2.1 && selectedSubQuestion?.optionThree) || (currentStep === 2 && question?.options[2]) || ""
                      }
                    />

                    <CustomTextEditor
                      labelTitle={"Option D"}
                      name="optionFour"
                      id="optionFour"
                      setValue={setValuesStepTwo}
                      setResetValue={setResetoptions}
                      resetValue={resetoptions}
                      showError={errorsStepTwo?.optionFour}
                      errorMessage={errorsStepTwo?.optionFour?.message}
                      showMandatory={true}
                      defaultValue={(
                        currentStep === 2.1 && selectedSubQuestion?.optionFour) || (currentStep === 2 && question?.options[3]) || ""
                      }
                    />
                    <div className="Correct_box py-0 mb-4 mt-2">
                      <div className="col-md-12 ps-0 px-2 pt-3">
                        <CustomDropDown
                          labelTitle="Correct Option"
                          placeholder="Select"
                          name="correctOption"
                          id="correctOption"
                          additionalClasses="profile_edit"
                          inputType={InputType.text}
                          showError={errorsStepTwo.correctOption} 
                          errorMessage={errorsStepTwo.correctOption?.message}
                          showMandatory={true}
                          setValue={setValuesStepTwo}
                          setCustomValue={setSubQuestionCorrectOption}
                          customValue={subQuestionCorrectOption}
                          options={DataProvider.answerOptions}
                          setResetValue={setResetcorrectoption}
                          resetValue={resetcorrectoption}
                          register={registerStepTwo}
                          parentProps={{ style: importantStyle }}
                          defaultValue={() => {
                            let correctOptionValue = question?.correctOption ?? "";
                            setValuesStepTwo("correctOption", correctOptionValue,);

                            return correctOptionValue === ""
                              ? DataProvider.answerOptions.find((e) => e.value === "")
                              : DataProvider.answerOptions.find((e) => e.value === correctOptionValue);
                          }}
                        />
                      </div>
                    </div>
                    <CustomTextEditor
                      labelTitle={"Solution"}
                      name="solution"
                      id="solution"
                      setValue={setValuesStepTwo}
                      showError={errorsStepTwo?.solution}
                      errorMessage={errorsStepTwo?.solution?.message}
                      setResetValue={setResetfield}
                      resetValue={resetfield}
                      defaultValue={(
                        currentStep === 2.1 && selectedSubQuestion?.solution) || (currentStep === 2 && question?.solution) || ""
                      }
                    />
                    {currentStep === 2.1 && (
                      <div className="d-flex justify-content-end mt-3 w-100 justify-content-between">
                        <button className="back_login m-0 cursor-pointer" onClick={() => setCurrentStep(2)}>
                          <Image src={SvgImages.back_arrow_login} className="m-0" />
                          Back
                        </button>
                        <ButtonWithIcon
                          text={
                            selectedSubQuestion &&
                              selectedSubQuestion.sub_question_id
                              ? "Update Question"
                              : "Add Question"
                          }
                          icon={
                            selectedSubQuestion &&
                              selectedSubQuestion.sub_question_id
                              ? SvgImages.tick_mark
                              : SvgImages.plus
                          }
                          onClick={handleSubmitStepTwo(revieweraddSubQuestion)}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className={`d-flex flex-column ${watchStepOne("typeOfQuestion") === "General"
                      ? "w-50"
                      : "w-100"
                      }`}
                  >
                    <CustomTextEditor
                      labelTitle={"Parent question"}
                      name="questions"
                      id="questions"
                      updateValue={question.question}
                      setValue={setValuesStepTwo}
                      setResetValue={setResetTopicDetailsValue}
                      resetValue={resetTopicDetailsValue}
                      showError={errorsStepTwo?.questions}
                      errorMessage={errorsStepTwo?.questions?.message}
                      showMandatory={true}
                      defaultValue={
                        (currentStep === 2.1 &&
                          selectedSubQuestion?.question) || "" ||
                        (currentStep === 2 && question?.question) ||
                        ""
                      }
                    />
                  </div>
                )}
                {currentStep === 2.1 &&
                  (watchStepOne("typeOfQuestion") === "Comprehensive" || watchStepOne("typeOfQuestion") === "Poem") && (
                    <div className="d-flex flex-column w-50 topic_card p-4">
                      <label className="fs-18 fw-600">Questions</label>
                      {allSubQuestions.length > 0 ? (
                        <div className="mt-2 gap-3 ">
                          {allSubQuestions?.map((data, index) => {
                            const correctOption = data.correctOption;
                            return (
                              <div
                                key={index}
                                className="subQuestion_cards mt-3 mb-4 "
                              >
                                <h5 className="mb-3 fs-16 fw-500">
                                  {index + 1}. {getTextFromHtml(data.question.replace(/&nbsp;/g, ' '))}
                                </h5>
                                <div className="d-flex flex-column gap-2">
                                  <div className={`${correctOption === 0 ? "subQuestion_option_selected" : "subQuestion_option"}`}>
                                    A. {data.optionOne}
                                  </div>
                                  <div className={`${correctOption === 1 ? "subQuestion_option_selected" : "subQuestion_option"}`}>
                                    B. {data.optionTwo}
                                  </div>
                                  <div className={`${correctOption === 2 ? "subQuestion_option_selected" : "subQuestion_option"}`}>
                                    C. {data.optionThree}
                                  </div>
                                  <div className={`${correctOption === 3 ? "subQuestion_option_selected" : "subQuestion_option"}`}>
                                    D. {data.optionFour}
                                  </div>
                                </div>

                                <div className="d-flex justify-content-end mb-0 ">
                                  <div
                                    className="cursor-pointer p-1"
                                    onClick={() => {
                                      setSubQuestionCorrectOption(DataProvider.answerOptions.find(
                                        (e) =>
                                          e.value ===
                                          data.correctOption
                                      ));

                                      setSelectedSubQuestion(null);
                                      setTimeout(() => {
                                        setSelectedSubQuestion(data);
                                      }, 0);
                                    }}
                                  >
                                    <Image
                                      src={SvgImages.edit}
                                      className="question_edit_image"
                                    />
                                  </div>
                                  <div className="bg-secondry p-1">:</div>
                                  <div
                                    className="cursor-pointer p-1"
                                    onClick={() => {
                                      setSubQuestionToDelete(data);
                                      setShowSubQuestionDeleteModal(true);
                                    }}
                                  >
                                    <Image
                                      src={SvgImages.deleteIcon}
                                      className="question_delete_image"
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="d-flex flex-column align-items-center justify-content-center my-3 h-100">
                          <Image
                            src={SvgImages.noTopics}
                            style={{ height: 250 }}
                          />
                          <h1 className="subText fs-20 fw-600 my-3">
                            No Questions Found
                          </h1>
                        </div>
                      )}
                    </div>
                  )}
              </div>

              {/* Footer */}
              <div className={`d-flex ${currentStep === 2.1 ? "justify-content-end" : "justify-content-between"} align-items-center w-100 mt-2`}>
                {currentStep === 2.1 ? null : <button className="back_login m-0 cursor-pointer" onClick={() => navigate(RoutesPath.reveiwerquestionslist)}>
                  <Image src={SvgImages.back_arrow_login} className="m-0" />
                  Back
                </button>}
                <ButtonWithIcon text={"Submit"} icon={SvgImages.right_arrow} onClick={(currentStep === 2.1 && (watchStepOne("typeOfQuestion") === "Comprehensive" || watchStepOne("typeOfQuestion") === "Poem")) ? (() => setCurrentStep(3)) : handleSubmitStepTwo(addQuestionApiTask)} />
              </div>
            </div>
          </form>
        ) : null
        }

        {currentStep === 3 ?
          <div className="d-flex flex-column align-items-center justify-content-center mt-4">
            <Image src={SvgImages.StudyMaterialAddedSuccess} style={{ height: 250 }} />
            <h1 className="primary fs-20 fw-600 mb-0">Well Done!</h1>
            <h3 className="black fs-14 fw-400 mb-0 mt-1">You have successfully update question</h3>

            <div className="d-flex justify-content-between align-items-center w-100 mt-5">
              <button className="back_login m-0 cursor-pointer" onClick={() => (watchStepOne("typeOfQuestion") === "Comprehensive" || watchStepOne("typeOfQuestion") === "Poem") ? setCurrentStep(2.1) : setCurrentStep(2)}>
                <Image src={SvgImages.back_arrow_login} className="m-0" />
                Back
              </button>
            </div>
          </div>
          : null
        }
      </div>

      {/* Delete Topic Modal */}
      <ConfirmationModal
        showModal={showSubQuestionDeleteModal}
        setShowModal={setShowSubQuestionDeleteModal}
        text={"Are you sure want to delete this question?"}
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          deleteSubQuestionApiTask(subQuestionToDelete);
        }}
        theme={ConfirmationModalTheme.error}
      />
    </div>
  );
};

export default ReviewerAddQuestionBank;